import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesPaymentInformationComponent} from "./sales-payment-information.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {SalesPaymentInformationGeneralComponent} from "./general/sales-payment-information-general.component";
import {SalesPaymentInformationKredicashComponent} from "./kredicash/sales-payment-information-kredicash.component";
import {
  SalesPaymentInformationKredicashV2Component,
  SalesPaymentInformationKredicashV3Component
} from "./kredicash/versions/sales-payment-information-kredicash-versions.component";
import {BankingTransferComponent} from "./platform/banking-transfer/banking-transfer.component";
import {BankingTransferComponentV3} from "./platform/banking-transfer-v3/banking-transfer-v3.component";
import {LukiBannerComponent} from "./platform/luki-banner/luki-banner.component";
import {LukiClientComponent} from "./platform/luki-client/luki-client.component";
import {LukiNewClientComponent} from "./platform/luki-new-client/luki-new-client.component";
import {YappyComponent} from "./platform/yappy/yappy.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {LibraryModule} from "library";
import {GeneralModule} from "../general/general.module";

@NgModule({
  declarations: [
    SalesPaymentInformationComponent,
    SalesPaymentInformationGeneralComponent,
    SalesPaymentInformationKredicashComponent,
    SalesPaymentInformationKredicashV2Component,
    SalesPaymentInformationKredicashV3Component,
    BankingTransferComponent,
    BankingTransferComponentV3,
    LukiBannerComponent,
    LukiClientComponent,
    LukiNewClientComponent,
    YappyComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    ReactiveFormsModule,
    FormsModule,
    LibraryModule,
    GeneralModule
  ],
  exports: [
    SalesPaymentInformationComponent,
    SalesPaymentInformationKredicashComponent,
    SalesPaymentInformationKredicashV3Component
  ]
})
export class SalesPaymentInformationModule { }
